const MissionSection = () => (
  <section className="py-24 md:py-32 bg-accent">
    <div className="container">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-warm-ink mb-4 font-medium">Our Purpose</p>
        <h2 className="text-3xl md:text-5xl font-heading font-semibold mb-6">Why We Exist</h2>
        <div className="w-16 h-px bg-warm mx-auto mb-10" />
        <p className="text-foreground/85 text-lg md:text-xl leading-relaxed mb-6 font-light">
          We exist because every family deserves a care partner who shows up with consistency, compassion, and the kind of dignity‑centered support that helps seniors feel safe, seen, and genuinely cared for.
        </p>
        <p className="text-foreground/75 text-base md:text-lg leading-relaxed mb-6 font-light">
          Nashville's seniors deserve more than managed care. They deserve a partner — someone who shows up beautifully prepared, genuinely invested, and deeply committed to making each day better than the last.
        </p>
        <p className="text-muted-foreground text-xs italic">
          Kinship Care Collective provides non-medical companion and life support services only. We complement — and never replace — your medical team.
        </p>
      </div>
    </div>
  </section>
);

export default MissionSection;
